module.exports = __webpack_public_path__ + "img/Link-20.ca9e858b.svg";